module.exports = __webpack_public_path__ + "static/media/European Union.ddfae661.png";